import { useMutation, useQueryClient } from '@tanstack/react-query';

import { overrideOrganizationHeader, parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';

import { apiClient } from '@cast/infrastructure-api';
import { ORGANIZATIONS_QUERY_KEY } from '@cast/infrastructure-organization';

export const useUpdateOrganizationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { id: string; name: string }) =>
      apiClient.user.updateOrganization(
        {
          id: payload.id,
          organization: payload,
        },
        {
          headers: overrideOrganizationHeader(payload.id),
        }
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ORGANIZATIONS_QUERY_KEY],
      });
      notify.success('Organization updated successfully');
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
